<template>
    <a v-if="is_external" :href="url" :target="link_target" :title="link_title" :class="classes" ref="el"><slot></slot></a>
    <router-link ref="el" v-else :to="url" :target="link_target" :title="link_title" :key="url" :class="classes"><slot></slot></router-link>
</template>

<script>
import { convertToRelativeLink } from "@/utils/urlUtils.js";

export default {
    name: 'link-item',

    props: {
        link: {
            type: Object,
            default: {},
        },

        to: {
            type: String,
            default: '',
        },

        new_window: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            is_newsletter: false,
            is_footer: false,
            is_external: false,
            url: '',
            link_target: '',
            link_title: '',
            classes: [],
        }
    },

    methods: {
        isFile (url) {
            url = new URL(url, location.origin);
            return url.pathname.split('/').pop().indexOf('.') > 0;
        },

        isEmail(url) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(url).toLowerCase());
        },
    },

    mounted() {
        this.url = '';
        this.link_target = '';

        if (Object.keys(this.link).length !== 0) {
            this.classes.push(this.link.classes)
            this.url = this.link.url;
            this.link_target = this.link.target;
            this.link_title = this.link.title;

        } 

        else if (this.isEmail(this.to)) {
            this.url = 'mailto:' + this.to;
        }
        
        else {
            // Use utility function to convert absolute URL to relative path
            this.url = convertToRelativeLink(this.to, window.globals.home_url);
        }

        // Additional cleanup for any remaining absolute URLs
        this.url = convertToRelativeLink(this.url, window.globals.home_url);

        if ((this.new_window || this.isExternal(this.url) || this.isFile(this.url) || this.link_target === '_black') && !this.isEmail(this.url)) {
            this.link_target = '_black';
            this.is_external = true;
            // console.log(this.url)

            if (this.isFile(this.url)) {
                const regex = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n]+)/;
                const regex2 = /\/([^\/]+)$/;

                if (!regex.test(this.url)) {
                    this.url = window.globals.home_url + this.url;
                    const match = this.url.match(regex2);
                    // console.log(match)
                    this.$nextTick(() => {
                        this.$refs.el.setAttribute('download', match ? match[1] : '');
                    });
                }
            }

        }

        // console.log(this.new_window , this.isExternal(this.url) , this.isFile(this.url) , this.link_target === '_black')

    },
}

</script>